/**-------------------------------
 *! Importation des pages          |
 *---------------------------------
 */

/**-------------------------------
 *! Pages communs                  |
 *---------------------------------
 */
export const COURS_NAVIGATION = "cours/"
export const INFO_COURS = "info-cours";
export const AJOUT_COURS_NAVIGATION = "ajout-cours"; 
export const MODIFIER_COURS_NAVIGATION ="modifier-cours/";
export const MODIFIER_COURS_ADMIN_NAVIGATION = COURS_NAVIGATION + MODIFIER_COURS_NAVIGATION;
export const INFOS_COURS_ADMIN_NAVIGATION = COURS_NAVIGATION + INFO_COURS;
export const PROFIL_NAVIGATION = "profil/";
export const PARAMETRE_NAVIGATION = "parametre/"
export const POLITIQUE_DE_CONFIDENTIALITE = "politique-de-confidentialite"

/** ------------------------------------------
 *! AUTHENTICATION NAVIGATION                 |
 * -------------------------------------------
 */
/** ------------------------------------------
 *! AUTHENTICATION NAVIGATION                 |
 * -------------------------------------------
 */
export const CONNEXION_NAVIGATION = "";
export const INSCRIPTION_NAVIGATION = "/inscription";
export const PASSWORD_OUBLIER_NAVIGATION = "mot-de-passe-oublie";
export const PASSWORD_RESET_NAVIGATION = "reinitialiser-mot-de-passe";

/**------------------------------------------
 *! ADMIN NAVIGATION                         |
 * ------------------------------------------
 */
export const ADMIN_NAVIGATION = "/a";
export const CATEGORIE_COURS_NAVIGATION = "categorie-cours";
export const USERS_ADMIN_NAVIGATION_ETUDIANTS = "etudiants";
export const USERS_ADMIN_NAVIGATION_PROFS = "profs";
export const ALL_COURS_NAVIGATION = "all-cours";
export const DASHBOARD_ADMIN_NAVIGATION = ADMIN_NAVIGATION + "/dashboard/";
export const COURS_ADMIN_NAVIGATION = "cours/";
export const CATEGORIE_COURS_ADMIN_NAVIGATION =
  COURS_ADMIN_NAVIGATION + CATEGORIE_COURS_NAVIGATION;
export const AJOUT_COURS__ADMIN =
  COURS_ADMIN_NAVIGATION + AJOUT_COURS_NAVIGATION;
export const USERS_ADMIN_NAVIGATION = "users/";
export const TABLEAU_USERS ='tableau-users'


export const MODIFIER_PROFIL = "modification-profil";
export const MODIFIER_PROFIL_NAVIGATION = PROFIL_NAVIGATION + MODIFIER_PROFIL;

export const MODIFIER_PROFIL_ADMIN_NAVIGATION =
  PROFIL_NAVIGATION + MODIFIER_PROFIL;
export const LISTE_PROF = "listeprof";
export const LISTE_ARCHIVE_NAVIGATION = "liste-archive/";
export const LISTE_ARCHIVE =  USERS_ADMIN_NAVIGATION + LISTE_ARCHIVE_NAVIGATION;
export const LISTE_ARCHIVE_STUDENT = USERS_ADMIN_NAVIGATION + USERS_ADMIN_NAVIGATION_ETUDIANTS + LISTE_ARCHIVE_NAVIGATION;

/**------------------------------------------
 *! PROF NAVIGATION                         |
 * ------------------------------------------
 */

export const PROF_NAVIGATION = "p";
export const DASHBOARD_PROF_NAVIGATION = PROF_NAVIGATION + "/dashboard/";
export const COURS_PROF_NAVIGATION = "cours/";

export const LIST_ETUDIANT = "listEtudiant";

export const ETUDIANTS_PROF_NAVIGATION = "etudiants/";
export const MODIFIER_PROFIL_PROF_NAVIGATION =
  PROFIL_NAVIGATION + MODIFIER_PROFIL;

/**------------------------------------------
 *! ETUDIANT NAVIGATION                         |
 * ------------------------------------------
 */
export const ETUDIANT_NAVIGATION = 'e';
export const DASHBOARD_ETUDIANT_NAVIGATION = ETUDIANT_NAVIGATION + '/dashboard/'
export const MODIFIER_PROFIL_ETUDIANT_NAVIGATION = PROFIL_NAVIGATION +  MODIFIER_PROFIL


